/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

import type { Context, HrTime, Attributes } from '@opentelemetry/api';
import type { WritableMetricStorage } from './WritableMetricStorage';

/**
 * Internal interface.
 */
export class MultiMetricStorage implements WritableMetricStorage {
  private readonly _backingStorages: WritableMetricStorage[];
  constructor(backingStorages: WritableMetricStorage[]) {
    this._backingStorages = backingStorages;
  }

  record(
    value: number,
    attributes: Attributes,
    context: Context,
    recordTime: HrTime
  ) {
    const storages = this._backingStorages;
    for (let i = 0; i < storages.length; i++) {
      storages[i].record(value, attributes, context, recordTime);
    }
  }
}
